<template>
  <div>
    <transition mode="out-in" name="vue-lb-content-transition" @afterEnter="enableImageTransition"
      @beforeLeave="disableImageTransition">
      <div v-if="media" v-show="lightBoxOn" ref="container" class="vue-lb-container">
        <div class="vue-lb-content">
          <div class="vue-lb-header">
            <span />
            <div v-show="showCaption" class="vue-lb-info" v-html="media[0].caption" />
            <v-btn v-if="media[select].type == 'img'" icon color="white" @click="descargar()" :loading="btnloading">
              <v-icon>mdi-download</v-icon>
            </v-btn>
            <button v-if="closable" type="button" :title="closeText" class="vue-lb-button-close" @click="closeLightBox">
              <slot name="close">
                <CloseIcon />
              </slot>
            </button> <!-- .vue-lb-button-close -->
          </div> <!-- .vue-lb-header -->
          <div class="vue-lb-figure" @click.stop>
            <transition mode="out-in" :name="modalImageTransitionName">
              <vue-pdf-app :pdf="media[select].src" v-if="media[select].type == 'pdf'"></vue-pdf-app>
              <img v-if="media[select].type == 'img'" :key="media[select].src" v-lazy="{
                src: media[select].src,
                loading: media[select].src,
                error: media[select].src,
              }" :srcset="media[select].srcset || ''" class="vue-lb-modal-image" :alt="media[select].caption">
              <div v-if="media[select].type == 'video'" id="ver" ref="video" style="border-radius: 10%;"></div>
              <div v-if="media[select].type == 'error'" class="errorClass">
                <v-icon color="white" size="80"> mdi-image-off </v-icon>
                <span>
                  No se pudo encontrar el archivo en este
                  momento. Intente de nuevo
                  más tarde
                </span>
              </div>
            </transition>
            <div class="vue-lb-footer">
              <div class="vue-lb-footer-info" />
              <div class="vue-lb-footer-count" v-show="showFooterCount">
                <slot name="footer" :current="select + 1" :total="media[0].paginas">
                  {{ select + 1 }} / {{ media[0].paginas }}
                </slot>
              </div>
            </div>
          </div>
        </div> <!-- .vue-lb-content -->
        <button v-if="media.length > 1 && mostrarprevious" type="button" class="vue-lb-arrow vue-lb-left"
          :title="previousText" @click.stop="previousImage()" :disabled="isPreviousButtonDisabled">
          <slot name="previous">
            <LeftArrowIcon />
          </slot>
        </button>

        <button v-if="media[0].paginas > 1 && mostrarnext" type="button" class="vue-lb-arrow vue-lb-right"
          :title="nextText" @click.stop="nextImage()" :disabled="isNextButtonDisabled">
          <slot name="next">
            <RightArrowIcon />
          </slot>
        </button>
      </div> <!-- .vue-lb-container -->
    </transition>
  </div>
</template>

<style src="./style.css"></style>
<script>
import { mapActions, mapState } from 'vuex'
import VuePdfApp from "vue-pdf-app";
import LeftArrowIcon from './LeftArrowIcon.vue'
import RightArrowIcon from './RightArrowIcon.vue'
import CloseIcon from './CloseIcon.vue'
import VideoIcon from './VideoIcon.vue'
import Archivos from '@/services/Archivos/Archivos.service.js';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

let Hammer

if (typeof window !== 'undefined') {
  Hammer = require('hammerjs')
}

export default {
  components: {
    LeftArrowIcon,
    RightArrowIcon,
    CloseIcon,
    VideoIcon,
    VuePdfApp
  },

  props: {
    media: {
      type: Array,
      required: true,
    },

    disableScroll: {
      type: Boolean,
      default: true,
    },

    showLightBox: {
      type: Boolean,
      default: true,
    },

    closable: {
      type: Boolean,
      default: true,
    },

    startAt: {
      type: Number,
      default: 0,
    },

    nThumbs: {
      type: Number,
      default: 7,
    },

    showThumbs: {
      type: Boolean,
      default: true,
    },

    showFooterCount: {
      type: Boolean,
      default: true,
    },

    // Mode
    autoPlay: {
      type: Boolean,
      default: false,
    },

    autoPlayTime: {
      type: Number,
      default: 3000,
    },

    siteLoading: {
      type: String,
      default: '',
    },

    showCaption: {
      type: Boolean,
      default: false,
    },

    lengthToLoadMore: {
      type: Number,
      default: 0,
    },

    closeText: {
      type: String,
      default: 'Close (Esc)',
    },

    previousText: {
      type: String,
      default: 'Previous',
    },

    nextText: {
      type: String,
      default: 'Next',
    },

    previousThumbText: {
      type: String,
      default: 'Previous',
    },

    nextThumbText: {
      type: String,
      default: 'Next',
    },
  },
  data() {
    return {
      select: this.startAt,
      lightBoxOn: this.showLightBox,
      timer: null,
      modalImageTransitionName: 'vue-lb-modal-image-no-transition',
      isPDF: false,
      mostrarnext: true,
      mostrarprevious: true,
      isPreviousButtonDisabled: false,
      isNextButtonDisabled: false,
      datos: null,
      btnloading: false
    }
  },

  computed: {
    ...mapState({ drawer: state => state.drawer }),
    ...mapState(['domain', 'informationPage']),
    thumbIndex() {
      const halfDown = Math.floor(this.nThumbs / 2)

      if (this.select >= halfDown && this.select < this.media[0].paginas - halfDown)
        return {
          begin: this.select - halfDown + (1 - (this.nThumbs % 2)),
          end: this.select + halfDown,
        }

      if (this.select < halfDown)
        return {
          begin: 0,
          end: this.nThumbs - 1,
        }

      return {
        begin: this.media[0].paginas - this.nThumbs,
        end: this.media[0].paginas - 1,
      }
    },

    imagesThumb() {
      if (this.siteLoading) {
        return this.media.map(({ thumb, type }) => ({
          src: thumb,
          type,
          loading: this.siteLoading,
          error: this.siteLoading,
        }))
      }

      return this.media.map(({ thumb, type }) => ({
        src: thumb,
        type,
      }))
    }
  },

  watch: {
    lightBoxOn(value) {
      if (document != null) {
        this.onToggleLightBox(value)
      }
    },

    select() {
      this.$emit('onImageChanged', this.select)

      if (this.select >= this.media[0].paginas - this.lengthToLoadMore - 1)
        this.$emit('onLoad')

      if (this.select === this.media[0].paginas - 1)
        this.$emit('onLastIndex')

      if (this.select === 0) {
        this.mostrarprevious = false;
        this.mostrarnext = true;
        this.$emit('onFirstIndex')
      }


      if (this.select === this.startAt)
        this.$emit('onStartIndex')
    },
  },

  async mounted() {

    this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
    if (this.autoPlay) {
      this.timer = setInterval(() => {
        this.nextImage()
      }, this.autoPlayTime)
    }

    this.onToggleLightBox(this.lightBoxOn)

    if (this.$refs.container) {
      const hammer = new Hammer(this.$refs.container)

      hammer.on('swiperight', () => {
        this.previousImage()
      })

      hammer.on('swipeleft', () => {
        this.nextImage()
      })
    }
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.addKeyEvent)

    if (this.autoPlay) {
      clearInterval(this.timer)
    }
  },

  methods: {
    async descargar() {
      this.btnloading = true;
      let formdata = new FormData();
      formdata.append("nrreporte", this.datos.nrreporte);
      formdata.append("svindice", this.datos.svindice);
      formdata.append("docid", this.media[0].docid);
      formdata.append("pagina", this.select + 1);
      let archi = await Archivos.ObtenerEnlaces(formdata);
      if (!archi.error) {
        var formData = new FormData();
        formData.append("lasitio", 'Prusia+');
        formData.append("lomodulo", "Documentos");
        formData.append("laaccion", "Descargó Documento");
        formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
        formData.append("lanombre", this.media[this.select].archivo);
        formData.append("ladestinatario", "");

        await Archivos.AlmacenarVisitas(formData);
        var link = document.createElement('a');
        document.body.appendChild(link);
        link.download = archi.archivo;
        link.href = archi.msg;
        link.className = 'aDownload';
        link.click();
        $(".aDownload").remove();
      } else {
        this.$swal({
          position: 'center',
          icon: 'warning',
          title: 'Correcto',
          text: 'Ocurrio un error, intentelo más tarde!!',
          showConfirmButton: false,
          timer: 2500
        });
      }
      this.btnloading = false;

    },
    async onLightBoxOpen() {
      this.$emit('onOpened')
      if (this.disableScroll) {
        document.querySelector('html').classList.add('no-scroll')
      }
      document.querySelector('body').classList.add('vue-lb-open')
      document.addEventListener('keydown', this.addKeyEvent)
      if (this.media[0].type == 'video') {
        await new Promise(resolve => setTimeout(resolve, 2000));
        var blobMe = URL['createObjectURL'](new Blob([''], { type: 'text/html' }));
        var elIframe = document['createElement']('iframe');
        elIframe['setAttribute']('frameborder', '0');
        elIframe['setAttribute']('width', '100%');
        elIframe['setAttribute']('height', '510px');
        elIframe['setAttribute']('min-width', '380px');
        elIframe['setAttribute']('min-height', '500px');
        elIframe['setAttribute']('allowfullscreen', 'true');
        elIframe['setAttribute']('webkitallowfullscreen', 'true');
        elIframe['setAttribute']('mozallowfullscreen', 'true');
        elIframe['setAttribute']('src', blobMe);
        var idOne = 'gepa_1';
        elIframe['setAttribute']('id', idOne);
        document.getElementById('ver').appendChild(elIframe);

        const iframeHere = "https://player.vimeo.com/video/" + this.media[0].src;
        document['getElementById'](idOne)['contentWindow']['document'].write('<script type="text/javascript">location.href = "' + iframeHere + '";\x3c/script>');
      }
      this.mostrarnext = true;
      this.mostrarprevious = true;
    },

    onLightBoxClose() {
      this.$emit('onClosed')
      if (this.disableScroll) {
        document.querySelector('html').classList.remove('no-scroll')
      }
      document.querySelector('body').classList.remove('vue-lb-open')
      document.removeEventListener('keydown', this.addKeyEvent)
      if (this.media[0].type == 'video') {
        const boxes = document.getElementById("gepa_1");
        boxes.remove();
      }
    },

    onToggleLightBox(value) {
      if (value) {
        this.onLightBoxOpen()
      } else {
        this.onLightBoxClose()
      }
    },

    showImage(index) {
      this.$set(this, 'select', index)
      this.$set(this, 'lightBoxOn', true)
    },

    addKeyEvent(event) {
      if (event.keyCode === 37) this.previousImage() // left arrow
      if (event.keyCode === 39) this.nextImage() // right arrow
      if (event.keyCode === 27) this.closeLightBox() // esc
    },

    closeLightBox() {
      if (!this.closable) return
      this.$set(this, 'lightBoxOn', false)
    },

    async nextImage() {
      this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
      this.isNextButtonDisabled = true;
      this.isNextButtonDisabled = true;
      if (typeof this.media[this.select + 1] == 'undefined') {
        let archivo = await Archivos.ObtenerDireccion(this.datos, this.media[0].docid, (this.media.length + 1));
        if (archivo.archivo !== null) {
          this.isPDF = /\.pdf$/i.test(archivo.archivo);
          var img = {
            src: archivo.watch,
            caption: '<h4>' + this.media[0].caption + '</h4>',
            type: this.isPDF == true ? 'pdf' : 'img',
            width: '800px',
            archivo: archivo.archivo
          };
          this.media.push(img);
        } else {
          var img = {
            type: 'error',
          };
          this.media.push(img);
        }
      }
      this.mostrarprevious = true;
      this.mostrarnext = ((this.select + 1) < (this.media[0].paginas - 1) ? true : false)
      this.$set(this, 'select', (this.select + 1) % this.media[0].paginas)
      this.isNextButtonDisabled = false;
      this.isNextButtonDisabled = false;

    },

    async previousImage() {
      this.mostrarnext = ((this.select + 1) < (this.media[0].paginas - 1) ? false : true)
      this.$set(this, 'select', (this.select + this.media[0].paginas - 1) % this.media[0].paginas)
    },

    enableImageTransition() {
      this.$set(this, 'modalImageTransitionName', 'vue-lb-modal-image-transition')
    },

    disableImageTransition() {
      this.$set(this, 'modalImageTransitionName', 'vue-lb-modal-image-no-transition')
    },
  },
}
</script>

